<template>
     <v-row>
          <v-col cols="12" md="5" sm="12">
               <v-sheet>
                    <v-img
                         lazy-src="https://picsum.photos/id/11/10/6"
                         :src="getImage()"
                         :height="getHeight()"
                         max-width="100%"
                         contain
                    ></v-img>
               </v-sheet>
          </v-col>
          <v-col cols="12" md="7" sm="12">
               <v-item-group mandatory v-model="groupItem">
                    <v-row style="padding-top: 0px">
                         <v-col
                              cols="2"
                              v-for="(item, i) in images"
                              :key="i"
                              style="padding-top: 0px"
                         >
                              <v-sheet
                                   class="pa-1"
                                   color="primary"
                                   height="100%"
                              >
                                   <v-item v-slot:default="{ toggle }">
                                        <v-img
                                             lazy-src="https://picsum.photos/id/11/10/6"
                                             max-height="150"
                                             max-width="250"
                                             :src="item"
                                             v-ripple
                                             @click="toggle"
                                             aspect-ratio="1"
                                        ></v-img>
                                   </v-item>
                              </v-sheet>
                         </v-col>
                    </v-row>
               </v-item-group>
          </v-col>
     </v-row>
</template>

<script>
export default {
     name: 'BaseImageGallery',
     props: {
          subtitle: String,
          title: {
               type: String,
               default: 'MAIL US YOUR MESSAGE',
          },
          images: Array,
     },
     computed: {},
     data: () => ({
          groupItem: 0,
     }),
     methods: {
          getImage() {
               if (!this.groupItem) return this.images[0]
               return this.images[this.groupItem]
          },
          getHeight() {
               const height = this.$vuetify.breakpoint.mdAndUp
                    ? '500px'
                    : '50vh'

               return `calc(${height}`
          },
     },
}
</script>
